import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { EuiLoadingSpinner, EuiPage } from '@elastic/eui'

import { apiGetOrganizationDirect, apiGetAccountDirect } from 'api/adcritterApi'
import { Organization, Account } from 'api/interfaces'
import { showSuccessToast, updateOrganizationAndAccountState } from 'app/appSlice'
import { RootState } from 'app/rootReducer'
import history from 'services/HistoryService'

interface GotoAdPageParams {
  organizationId: string
  accountId: string
  campaignId: string
  adId: string
}

const GotoAdPage: React.FC = () => {
  const dispatch = useDispatch()
  const { currentUser } = useSelector((state: RootState) => state.app)
  let { organizationId, accountId, campaignId, adId } = useParams<GotoAdPageParams>()
  const [organization, setOrganization] = useState<Organization>()
  const [account, setAccount] = useState<Account>()

  useEffect(() => {
    if (currentUser && !currentUser.roles.includes('staff')) {
      history.push('/dashboard')
    }
    if (currentUser && currentUser.roles.includes('staff')) {
      if (organizationId) {
        apiGetOrganizationDirect(organizationId).then(result => setOrganization(result.data))
      }

      if (accountId) {
        apiGetAccountDirect(accountId).then(result => setAccount(result.data))
      }
    }
  }, [currentUser, organizationId, accountId])

  useEffect(() => {
    if (organization && account) {
      dispatch(updateOrganizationAndAccountState({ account: account, organization }))
      dispatch(showSuccessToast(`Switching organization to ${organization.name}`))

      if (adId && campaignId) {
        history.push(`/campaigns/ads/${campaignId}/edit/${adId}`)
      } else {
        history.push(`/dashboard`)
      }
    }
  }, [dispatch, organization, account, campaignId, adId])

  return (
    <EuiPage className='euiPage--platform'>
      <EuiLoadingSpinner size='xl' style={{ margin: 32 }} />
    </EuiPage>
  )
}

export default GotoAdPage
